var React = require('react');
var ReactNative = require('react-native');


var Animated = require('./wrappers/Animated')

var MK = require('./wrappers/react-native-material-kit-wrapper');
var ReUpText = require('./ReUpText.js');

var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton,
} = MK;

var {
  AppRegistry,
  View,
  Text,
  StyleSheet,
} = ReactNative;

var MKSegmentControl = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      selectedIndex : 0,
      activeBackgroundColor : 'blue',
      activeShadowColor : 'red',
      activeTextColor : 'black',
      activeRippleColor : 'rgba(255,255,255,.2)',
      inactiveBackgroundColor : 'purple',
      inactiveTextColor : 'black',
      inactiveRippleColor : 'rgba(255,255,255,.2)',
      choiceTitles : ["title1","title2"],
      didSelectIndex : function(index) {},
    }
  },

  getInitialState : function()
  {
    return {
      selectedIndex : this.props.selectedIndex,
    }
  },

  componentDidMount : function()
  {
  },

  didSelectIndex : function(index)
  {
    this.setState({selectedIndex:index});
    this.props.didSelectIndex(index);
  },

  setSelectedIndex : function(index)
  {
    this.didSelectIndex(index);
  },

  render: function()
  {
    var selectedIndex = this.state.selectedIndex;
    var activeBackgroundColor = this.props.activeBackgroundColor;
    var activeShadowColor = this.props.activeShadowColor;
    var activeTextColor = this.props.activeTextColor;
    var activeRippleColor = this.props.inactiveBackgroundColor.indexOf("rgba") == 0 ? this.props.inactiveBackgroundColor.replace("\,1\)", ",.4)") : this.props.activeRippleColor;
    var inactiveBackgroundColor = this.props.inactiveBackgroundColor;
    var inactiveTextColor = this.props.inactiveTextColor;
    var inactiveRippleColor = this.props.activeBackgroundColor.indexOf("rgba") == 0 ? this.props.activeBackgroundColor.replace("\,1\)", ",.4)") : this.props.inactiveRippleColor;
    var didSelectIndex = this.didSelectIndex;

    return (
      <View style={this.props.style}>
        <View style={[styles.choicesContainer, {backgroundColor:inactiveBackgroundColor, elevation:2}]}>
          {
            this.props.choiceTitles.map(function(title, index)
            {
              var rippleColor = selectedIndex != index ? inactiveRippleColor : activeRippleColor;
              return (
                <MKButton key={index} style={[styles.choiceButton]}
                  backgroundColor={selectedIndex == index ? activeBackgroundColor : inactiveBackgroundColor}
                  shadowRadius={2}
                  shadowOffset={{width:0, height:2}}
                  shadowOpacity={.7}
                  shadowColor={selectedIndex == index ? activeShadowColor : "transparent"}
                  rippleColor={rippleColor}
                  maskBorderRadius={0}
                  onPress={() => {
                    didSelectIndex(index);
                  }}
                  >
                  <ReUpText pointerEvents="none"
                        style={{
                                lineHeight:24,
                                textAlign:'center',
                                color: selectedIndex == index ? activeTextColor : inactiveTextColor,
                                backgroundColor:'transparent',
                                fontWeight: 'normal',}}>
                    {title}
                  </ReUpText>
                </MKButton>
              )
            })
          }
          </View>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  choicesContainer: {
    flexDirection:'row',
    borderRadius:2,
  },
  choiceButton: {
    justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    flex:1,
    height:40,
  },
});

module.exports = MKSegmentControl;
